import React from 'react'
import css from "./Header.module.css"
import logo from "../../assets/logo.png"
import{CgShoppingBag} from "react-icons/cg"
import{GoThreeBars} from "react-icons/go"
const Header = () => {
  const [showMenu, setshowMenu] = React.useState(true)
  const toogleMenu = () =>{
    setshowMenu((prev)=>!prev)
  }
  return (
    <div className={css.container}>
<div className={css.logo}>
<img src={logo} alt="" />
<span>AmazShop</span>
</div>

<div className={css.right}>
  <div className={css.bars} onClick={()=>toogleMenu()}>
    <GoThreeBars />
  </div>
 <ul className={css.menu} style={{display: showMenu? "inherit":"none"}}>
    <li>Collections</li>
    <li>Brand</li>
    <li>New</li>
    <li>Sales</li>
    <li>ENG</li>
</ul>
     <input type="text" placeholder='Search...' className={css.searchbar} />
    <CgShoppingBag className='cart'/>
</div>
    </div>
  )
}

export default Header